export default __webpack_public_path__ + "static/media/stripe.38b202e7.svg";